import { render, staticRenderFns } from "./ActionPaoLinkComponent.vue?vue&type=template&id=2fb7a8d8&scoped=true"
import script from "./ActionPaoLinkComponent.vue?vue&type=script&lang=js"
export * from "./ActionPaoLinkComponent.vue?vue&type=script&lang=js"
import style0 from "./ActionPaoLinkComponent.vue?vue&type=style&index=0&id=2fb7a8d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb7a8d8",
  null
  
)

export default component.exports